var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as actions from 'app/actions/session';
import http from 'app/services/http';
export const sessionReducer = (state = {
    ip: null,
    session: null,
    secret: null,
    timezone: moment().utcOffset(),
    currentDate: moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
}, action) => {
    switch (action.type) {
        case 'SESSION_SET_IP': {
            const { value } = action.payload;
            return Object.assign(Object.assign({}, state), { ip: value });
        }
        case 'SESSION_SET_DATA': {
            const { session } = action.payload;
            return Object.assign(Object.assign({}, state), { session: session });
        }
        case 'SESSION_CURRENT_DATE': {
            const { datetime } = action.payload;
            return Object.assign(Object.assign({}, state), { currentDate: datetime });
        }
        case 'SESSION_SET_SECRET': {
            const { secret } = action.payload;
            return Object.assign(Object.assign({}, state), { secret: secret, setupSecret: secret ? state.setupSecret : false });
        }
        case 'SESSION_SET_SETUP_SECRET': {
            const { flag = true } = action.payload;
            return Object.assign(Object.assign({}, state), { secret: Object.assign(Object.assign({}, state.secret), { setupQrCode: flag }) });
        }
        default:
            return state;
    }
};
export function sessionGetIp() {
    return function sessionGetIpThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.get('/user/ipinfo');
            return dispatch(actions.setSessionIp(data.ip));
        });
    };
}
export function sessionCheckOut() {
    return function sessionCheckOutThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            return http
                .post('/user/checkin')
                .then((response) => response.data)
                .catch((response) => response.data)
                .then(({ ip, secret = null, user = null }) => {
                dispatch(actions.setSessionIp(ip));
                dispatch(actions.setSessionSecret(secret));
                dispatch(actions.setSessionData(user));
            });
        });
    };
}
export function sessionSignIn(email, password) {
    return function sessionSignInThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            return http
                .post('/user/signin', { email, password })
                .then((response) => {
                return response.data;
            })
                .then(({ secret, user = null }) => {
                dispatch(actions.setSessionSecret(secret));
                dispatch(actions.setSessionData(user));
            });
        });
    };
}
export function sessionSetup2Fa() {
    return function sessionSetup2FaThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            return http.post('/user/setup-2fa').then(() => {
                dispatch(actions.setSessionSetupSecret(true));
            });
        });
    };
}
export function sessionCheck2Fa(code) {
    return function sessionCheck2FaThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            return http
                .post('/user/check-2fa', { code })
                .then((response) => response.data)
                .then((response) => {
                dispatch(actions.setSessionData(response));
                dispatch(actions.setSessionSecret(null));
            });
        });
    };
}
export function sessionReset2Fa() {
    return function sessionReset2FaThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            return http.post('/user/reset-2fa').then(() => {
                dispatch(actions.setSessionData(null));
                dispatch(actions.setSessionSecret(null));
            });
        });
    };
}
export function sessionSignOut() {
    return function sessionSignOutThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post('/user/signout');
            return dispatch(actions.deleteSessionData());
        });
    };
}
export function sessionResetPassword(email) {
    return function sessionResetPasswordThunk() {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post('/user/forgot', { email });
        });
    };
}
export function sessionConfirmResetPassword(code) {
    return function sessionConfirmResetPasswordThunk() {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post('/user/forgot/confirm', { code });
        });
    };
}
export function sessionSetResetPassword(password) {
    return function sessionSetResetPasswordThunk() {
        return __awaiter(this, void 0, void 0, function* () {
            yield http.post('/user/forgot/install', { password });
        });
    };
}
// Смена собственного пароля: ответ содержит обновлённого пользователя
// с снятым флагом must_change_password — по нему роутер снимает гейт.
export function sessionChangeOwnPassword(password) {
    return function sessionChangeOwnPasswordThunk(dispatch) {
        return __awaiter(this, void 0, void 0, function* () {
            const { data } = yield http.post('/user/password', { password });
            return dispatch(actions.setSessionData(data));
        });
    };
}
export default sessionReducer;
